import { Controller } from 'stimulus';

// Keeps the wishlist add button in sync with the selected wishlist option.
// The wishlist button-with-select partial renders each option with
// data-wishlist-added to say whether the current variant is already in that
// wishlist. When shoppers switch the wishlist dropdown, this controller updates
// the button color and heart icon immediately, without waiting for a form submit
// or Turbo frame refresh.
export default class extends Controller {
  static targets = ['select', 'button', 'addedIcon', 'notAddedIcon'];

  connect() {
    this.sync();
  }

  sync() {
    if (!this.hasSelectTarget) return;

    const option = this.selectTarget.selectedOptions[0];
    const added = option && option.dataset.wishlistAdded === 'true';

    // Match the server-rendered state from the button-with-select partial
    // after the user changes the selected wishlist.
    this.buttonTarget.classList.toggle('btn-primary', added);
    this.buttonTarget.classList.toggle('btn-light', !added);
    this.buttonTarget.classList.toggle('btn-outline-secondary', !added);
    this.addedIconTarget.classList.toggle('d-none', !added);
    this.notAddedIconTarget.classList.toggle('d-none', added);
  }
}
